import React, { useState, useEffect } from 'react';
import '../Styles/LoadingSpinner.css';

const LoadingSpinner = () => {
  const tips = [
    'Setting up...',
    'Please wait...',
    'Getting ready...',
    'One moment...',
    'Almost there...'
  ];

  const statuses = ['Initializing...', 'Loading data...', 'Ready!'];

  const [currentTipIndex, setCurrentTipIndex] = useState(0);
  const [currentStatusIndex, setCurrentStatusIndex] = useState(0);

  useEffect(() => {
    const tipInterval = setInterval(() => {
      setCurrentTipIndex((prev) => (prev + 1) % tips.length);
    }, 3000);

    return () => clearInterval(tipInterval);
  }, [tips.length]);

  useEffect(() => {
    const statusInterval = setInterval(() => {
      setCurrentStatusIndex((prev) => (prev + 1) % statuses.length);
    }, 2000);

    return () => clearInterval(statusInterval);
  }, [statuses.length]);

  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-wrapper">
        {/* Glow background effect */}
        <div className="spinner-glow"></div>

        {/* Animated spinner circle with glow */}
        <div className="spinner-circle"></div>
        
        {/* Orbiting dots */}
        <div className="orbiting-dots">
          <div className="dot dot-1"></div>
          <div className="dot dot-2"></div>
          <div className="dot dot-3"></div>
        </div>

        {/* Loading text with animation */}
        <div className="loading-text-wrapper">
          <h2 className="loading-title">NoteForge</h2>
          <p className="loading-status">{statuses[currentStatusIndex]}</p>
        </div>

        {/* Tips/Helpful Messages */}
        <div className="tips-container">
          <p className="loading-tip">{tips[currentTipIndex]}</p>
        </div>

        {/* Progress bar */}
        <div className="progress-bar-container">
          <div className="progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
